import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "index";
import { useNavigate } from "react-router-dom";

export const useAuthStateChange = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useEffect(() => {
    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if (
        event === "SIGNED_IN" &&
        (window.location.pathname === "/login" || window.location.pathname === "/")
      ) {
        navigate("/", { replace: true });
        queryClient.clear();
      }

      if (event === "SIGNED_OUT") {
        navigate("/", { replace: true });
        queryClient.clear();
      }
    });

    return () => {
      sub.subscription.unsubscribe();
    };
  }, [navigate, queryClient]);
};
